interface Order {
  readonly order_fulfillment_time: number;
  readonly customer: string;
}
export function compareOrders(a: Order, b: Order): number {
  const aTime = a.order_fulfillment_time;
  const bTime = b.order_fulfillment_time;
  const aName = a.customer;
  const bName = b.customer;

  // Fisrt compare by time
  if (aTime < bTime) {
    return -1;
  }
  if (aTime > bTime) {
    return 1;
  }

  // If times are equal, compare by name
  return aName.localeCompare(bName);
}
